import React, { useState, useRef } from "react";
import popupImg from "../../assets/images/popupImg.png";
import { IoPlayOutline } from "react-icons/io5";
import { IoPlaySharp } from "react-icons/io5";
import { IoIosCloseCircleOutline } from "react-icons/io";
import useOutsideClick from "../../hooks";

const LaunchingSoonModal = ({ isOpen, onClose }) => {
    const modalRef = useOutsideClick(() => {
        onClose();
      });

  if (!isOpen) return null;

  const handleContactClick = () => {
    onClose();
    window.scrollTo({ top: document.body.scrollHeight, behavior: "smooth" });
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">

      <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
          <div
            ref={modalRef}
            className=" rounded-xl shadow-lg w-[90%] h-[75%] sm:w-[45%] md:w-[40%] xl:w-[35%] sm:h-[80%] bg-white p-3"
          >
            <div className="flex justify-end">
              <button
               onClick={onClose}
                className="text-secondaryText  text-3xl rounded "
              >
                <IoIosCloseCircleOutline />
              </button>
            </div>

            <img
              src={popupImg}
              alt="Modal Animation"
              className="w-full h-[85%] xl:h-[87%]"
            />
            <div className="flex justify-end">
              <p
                className=" text-base sm:text-xl  border-b-white cursor-pointer text-secondaryText font-semibold flex items-center gap-1"
                onClick={handleContactClick}
              >
                Contact Us
                <span className="text-base sm:text-xl font-semibold flex items-center">
                  <IoPlayOutline /> <IoPlaySharp /> <IoPlayOutline />
                </span>
              </p>
            </div>
          </div>
        </div>
    </div>
  );
};

export default LaunchingSoonModal;
